import { resolve } from 'rsvp';
export default function continueOnReject(promise) {
  return resolve(promise).catch(e => e);
}